import React from 'react';

export const FlagCLIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 400" // Standard 3:2 ratio
    {...props}
  >
    <rect width="600" height="400" fill="#D52B1E" rx="2"/> {/* Red (bottom half) */}
    <rect width="600" height="200" fill="#FFFFFF" /> {/* White (top half) */}
    <rect width="200" height="200" fill="#0039A6" /> {/* Blue canton (square, 1/3 width, 1/2 height) */}
    {/* Star */}
    <polygon
      points="100,60 115.45,97.55 159.55,97.55 122.05,120.45 137.5,158 100,135 62.5,158 77.95,120.45 40.45,97.55 84.55,97.55"
      fill="#FFFFFF"
    />
  </svg>
);